enum VaultTypeNameEnum {
  Password = 'login',
  SecureNote = 'secureNote',
  CreditCard = 'creditCard'
}

export default VaultTypeNameEnum;
